import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IVinculoConsulta } from '../../shared/interfaces/sisben/sisben';

@Injectable({
  providedIn: 'root'
})
export class VinculoService {
  private readonly baseUrl = `${environment.apiUrl}/api/datasets-dinamicos/sisben/vinculo`;

  constructor(private readonly http: HttpClient) { }

  findAll(): Observable<IVinculoConsulta[]> {
    return this.http.get<IVinculoConsulta[]>(this.baseUrl);
  }
}
